import { Controller } from "@hotwired/stimulus"

// Text fields and widgets that keep their own keys; a focused checkbox does not. Kept in sync with the lead sidebar controller.
const TYPING_SELECTOR = "input:not([type='checkbox']):not([type='radio']):not([type='button']):not([type='submit']):not([type='reset']), textarea, select, [contenteditable]:not([contenteditable='false']), [role='textbox'], [role='combobox'], [role='listbox'], [role='menu']"

// Opens the shortcut list when "?" is pressed outside a text field.
export default class extends Controller {
  connect() {
    this.keydown = event => this.open(event)
    document.addEventListener("keydown", this.keydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.keydown)
  }

  open(event) {
    if (event.key !== "?" || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey) return
    if (event.target.isContentEditable || event.target.closest?.(TYPING_SELECTOR)) return
    if (document.querySelector("dialog[open]")) return

    const dialog = this.element.querySelector("dialog")
    if (!dialog) return
    event.preventDefault()
    dialog.showModal()
    dialog.focus()
  }
}
